<template>
    <div class="select">
        <label v-if="label">{{ label }} :</label>
        <select v-bind="$attrs" :value="value" v-on="listeners">
            <slot/>
        </select>
    </div>
</template>
<script>
export default {
    name: 'Select',
    inheritAttrs: false,
    props: {
        value: {
            type: String,
            default: '',
        },
        label: {
            type: String,
            default: '',
        },
    },
    computed: {
        listeners () {
            return {
                ...this.$listeners,
                input: this.onInput,
            };
        },
    },
    methods: {
        onInput (e) {
            this.$emit('input', e.target.value);
        },
    },
};
</script>
<style lang="scss" scoped>
@import '../../assets/scss/colors';

.select {
    > label {
        display: block;
        padding: 8px 0;
        font-size: 12px;
        text-align: left;
        color: $black;
    }

    > select {
        display: block;
        width: 100%;
        padding: 16px;
        outline: none;
        border: 1px solid $grey-lightest;
        border-radius: 4px;
        background-color: $white-darkest;
        font-family: inherit;
        font-size: 14px;
        transition: border .1s ease-in-out;

        &:disabled {
            pointer-events: none;
        }
    }
}
</style>
